// src/components/MapSVG.js
import React from "react";
import { motion } from "framer-motion";

const svgVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { scale: 0, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: { type: "spring", stiffness: 150, damping: 10 },
  },
};

const mapPathVariants = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: {
      pathLength: 1,
      opacity: 1,
      transition: { duration: 1.5, ease: "easeInOut" },
    },
}

export default function MapSVG({ gradientId }) {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      variants={svgVariants}
      initial="hidden"
      animate="visible"
    >
      {/* 지도 윤곽선 */}
      <motion.path
        d="M50,5 C25,5 5,25 5,50 S25,95 50,95 95,75 95,50 75,5 50,5 Z M50,15 C69.3,15 85,30.7 85,50 S69.3,85 50,85 15,69.3 15,50 30.7,15 50,15 Z"
        fill={`url(#${gradientId})`}
        fillOpacity={0.1}
        stroke={`url(#${gradientId})`}
        strokeWidth="2"
        variants={mapPathVariants}
      />
      
      {/* 위치 핀 */}
      <motion.circle cx="50" cy="35" r="5" fill={`url(#${gradientId})`} variants={itemVariants} />
      <motion.circle cx="35" cy="60" r="5" fill={`url(#${gradientId})`} variants={itemVariants} />
      <motion.circle cx="68" cy="65" r="5" fill={`url(#${gradientId})`} variants={itemVariants} />
    </motion.svg>
  );
}